import React from 'react';

const IFC_Load = () =>
{ 

  return (
    <div className="">
      <iframe 
        src="https://chuongmep.github.io/ifcjs-webpack/"
        style={{
          border: 'none',
          margin: 0,
          padding: 0,
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%'
        }}
        allowFullScreen
      />
    </div>
  );
};

export default IFC_Load;